import React, {Component} from 'react';
import * as noroute from "../../assets/noroute.jpg";

class NoRoute extends Component {
    render() {
        return (<div>
        <img src ={noroute} style={{position:'absolute',top:'0',left:'0',width:'100%',maxHeight:'100%',border:'0',zIndex:'-777'}} alt="404 Not Found"/>
        </div>);
    }

}

export default NoRoute;


// WEBPACK FOOTER //
// ./src/views/universal/noroute.js